import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {useTranslation} from '@/translations/i18n'
import {Helmet} from 'react-helmet'
import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {DashboardEconomicPerformanceChart} from '@/features/dashboard/components/dashboard-economic-performance-chart/DashboardEconomicPerformanceChart'
import {DashboardSection} from '@/features/dashboard/components/dashboard-section/DashboardSection'
import {DashboardReimbursedAccessesCard} from '@/features/dashboard/components/dashboard-reimbursed-accesses-card/DashboardReimbursedAccessesCard'
import {DashboardCalculatedCostsCard} from '@/features/dashboard/components/dashboard-calculated-costs-card/DashboardCalculatedCostsCard'
import {DashboardFirstMarginCard} from '@/features/dashboard/components/dashboard-first-margin-card/DashboardFirstMarginCard'
import {DashboardOtherCostsCard} from '@/features/dashboard/components/dashboard-other-costs-card/DashboardOtherCostsCard'
import {DashboardOperatingMarginCard} from '@/features/dashboard/components/dashboard-operating-margin-card/DashboardOperatingMarginCard'
import {Scrollbar} from '@/components/ui/scrollbar/Scrollbar'
import {ScrollArea} from '@/components/ui/scroll-area/ScrollArea'
import {DashboardEconomicFilters} from '@/features/dashboard/components/dashboard-economic-filters/DashboardEconomicFilters'
import {DashboardEconomicSummaryCard} from '@/features/dashboard/components/dashboard-economic-summary-card/DashboardEconomicSummaryCard'
import {StyledDashboardEconomicWrapper} from './style'

export const DashboardEconomic = () => {
    const {t} = useTranslation()

    return (
        <StyledDashboardEconomicWrapper>
            <Helmet title={`${t('commons:dashboard')} | ${t('dashboard:economic')}`} />
            <DashboardEconomicFilters />
            <ScrollArea scrollbar={<Scrollbar />}>
                <Flexbox direction="column" fullWidth>
                    <DashboardSection title={t('dashboard:economic_performance')}>
                        <Flexbox direction="column" gap={6} fullWidth>
                            <DashboardEconomicPerformanceChart />
                            <Grid columns={3} gap={6} fullWidth>
                                <DashboardReimbursedAccessesCard />
                                <DashboardCalculatedCostsCard />
                                <DashboardFirstMarginCard />
                            </Grid>
                            <Grid columns={2} gap={6} fullWidth>
                                <DashboardOtherCostsCard />
                                <DashboardOperatingMarginCard />
                            </Grid>
                        </Flexbox>
                    </DashboardSection>
                    <DashboardSection title={t('dashboard:summary')}>
                        <DashboardEconomicSummaryCard />
                    </DashboardSection>
                </Flexbox>
            </ScrollArea>
        </StyledDashboardEconomicWrapper>
    )
}
